export default {
  "open": "agrandir trou {number} image",
  "title": "{course} · trou {number} image",
  "back": "Retour à la marque",
  "hole": "Trou {number}",
  "description": "{course} · Trou {number}",
  "loading": "Chargement de l'image...",
  "error": "Cette image n'a pas pu être chargée.",
  "retry": "Réessayer",
  "zoom": "agrandir",
  "out": "Zoom.",
  "reset": "Effacer le zoom",
  "in": "Zoom avant"
}
